var React = require('react');

function TriangleInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"triangle"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Welcome","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M15.9997878,0 L0,45 L32,45 L15.9997878,0 Z M15.9997878,10.2690252 L27.1433082,41.6101152 L4.85626733,41.6101152 L15.9997878,10.2690252 Z","id":"triangle","fill":"#FEFEFE","transform":"translate(16.000000, 22.500000) rotate(180.000000) translate(-16.000000, -22.500000) "}))]);
}

TriangleInline.defaultProps = {"width":"32px","height":"45px","viewBox":"0 0 32 45","version":"1.1"};

module.exports = TriangleInline;

TriangleInline.default = TriangleInline;
